export default "https://cdn-static.gokick.com/assets/3cd141d05df56e6b81a0153ff619f4101846aa93/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";